export default class HexWord {
    constructor() {
        this.title = localStorage.getItem("title");
        this.terms = localStorage.getItem("terms").split("\n");
        this.sortedTerms = localStorage.getItem("terms").split("\n").sort(function (a, b) {
            return b.length - a.length;
        });
        this.definitions = localStorage.getItem("definitions").split("\n");
        this.right = [];
        this.down = [];
        this.up = [];
        this.grid = [];
        this.crossGrid = [];
        this.size = this.sortedTerms[0] ? this.sortedTerms[0].length : 1;
        this.intersections = 0;
        this.placedTerms = 0;

        this.attempts = 0;
        this.ATTEMPTSMAX = 50;
        for (var i = 0; i < this.size * 1.5; i++) {
            this.grid[i] = [];
            this.crossGrid[i] = [];
        }

        while (this.attempts < this.ATTEMPTSMAX && (!this.placeTerms() || this.intersections < this.terms.length - 1)) {
            this.size++;
            this.attempts++;
            this.reset();
        }
    }
    placeTerms() {
        var location;
        for (var i = 0; i < this.terms.length; i++) {
            location = this.getRandomLocation(this.terms[i], this.grid);
            if (location) {
                if (location[3] && location[2]) {
                    this.down.push(this.definitions[i]);
                    this.crossGrid[location[0]][location[1]] = this.down.length;
                } else if (location[3]) {
                    this.up.push(this.definitions[i]);
                    this.crossGrid[location[0]][location[1]] = this.up.length;
                } else {
                    this.right.push(this.definitions[i]);
                    this.crossGrid[location[0]][location[1]] = this.right.length;
                }
                for (var j = 0; j < this.terms[i].length; j++) {
                    this.grid[location[0] + j * location[2]][location[1] + j * location[3]] = this.terms[i].charAt(j);
                }
                this.placedTerms++;
            } else if (this.attempts < this.ATTEMPTMAX) {
                return false;
            }
        }
        return true;
    };
    getRandomLocation(term) {
        /* Only returns valid locations for the term */
        var locations = [];
        var valid = false;
        // right, down, up
        var directions = [[1, 0], [1, 1], [0, -1]];
        var dx,
            dy;
        var intersections;
        for (var i = 0; i < this.size; i++) {
            for (var j = 0; j < this.size; j++) {
                for (var k = 0; k < directions.length; k++) {
                    dx = directions[k][0];
                    dy = directions[k][1];
                    intersections = 0;
                    // Confirm that the (i,j) point is within the bounds of the hex area.
                    if (2 * i >= j && 2 * i + 2 * dx * term.length >= j + dy * term.length)
                        if (i + dx * term.length <= this.size + Math.floor(j + dy * term.length) / 2)
                            if (i + dx * term.length >= 0 && j + dy * term.length >= 0 && j + dy * term.length < this.size) {
                                valid = true;
                                for (var l = 0; l < term.length; l++) {
                                    if (this.grid[i + l * dx][j + l * dy]) {
                                        if (this.grid[i + l * dx][j + l * dy] != term.charAt(l)) {
                                            // The character at (i+l*dx,j+l*dy) does not match
                                            valid = false;
                                            break;
                                        } else
                                            intersections++;
                                    } else {
                                        if (dy) {
                                            // Check left and right if down or up
                                            if ((i + l * dx + 1 < this.size * 1.5 && this.grid[i + l * dx + 1][j + l * dy]) || (i + l * dx > 0 && this.grid[i + l * dx - 1][j + l * dy])) {
                                                valid = false;
                                                break;
                                            }
                                        } else {
                                            // Check up and down if right
                                            if ((j + 1 < this.size && this.grid[i + l * dx][j + 1]) || (j > 0 && this.grid[i + l * dx][j - 1])) {
                                                valid = false;
                                                break;
                                            }
                                        }
                                    }
                                }
                                // Check the start point and end point
                                if (dx && dy) {
                                    if ((i > 0 && j > 0 && this.grid[i - 1][j - 1]) || (i + term.length < this.size * 1.5 && this.grid[i + term.length][j + term.length])) {
                                        valid = false;
                                        break;
                                    } else if (this.crossGrid[i][j] && this.crossGrid[i][j] != this.down.length - 1) {
                                        valid = false;
                                        break;
                                    }
                                } else if (dx) {
                                    if ((i > 0 && this.grid[i - 1][j]) || (i + term.length < this.size * 1.5 && this.grid[i + term.length][j])) {
                                        valid = false;
                                        break;
                                    } else if (this.crossGrid[i][j] && this.crossGrid[i][j] != this.right.length - 1) {
                                        valid = false;
                                        break;
                                    }
                                } else {
                                    if (this.grid[i][j + 1] || (j - term.length >= 0 && this.grid[i][j - term.length])) {
                                        valid = false;
                                        break;
                                    } else if (this.crossGrid[i][j] && this.crossGrid[i][j] != this.up.length - 1) {
                                        valid = false;
                                        break;
                                    }
                                }
                                if (intersections == 0 && this.placedTerms > 0)
                                    valid = false;
                                if (valid)
                                    locations.push([i, j, dx, dy, intersections]);
                            }
                }
            }
        }
        locations.sort(function (a, b) {
            return b[4] - a[4];
        });
        for (var i = 0; i < locations.length; i++)
            if (locations[i][4] < locations[0][4]) {
                locations.splice(i, 1);
                i--;
            }
        var target = locations[Math.floor(Math.random() * locations.length)];
        if (target && target[4] > 0)
            this.intersections += target[4];
        return target;
    };
    reset() {
        this.grid = [];
        this.crossGrid = [];
        for (var i = 0; i < this.size * 1.5; i++) {
            this.grid[i] = [];
            this.crossGrid[i] = [];
        }
        this.up = [];
        this.down = [];
        this.right = [];
        this.intersections = 0;
        this.placedTerms = 0;
    };
    create(worksheet) {
        // Create title
        var title = document.createElement("h4");
        title.className = 'text-center';
        title.innerHTML = this.title;
        worksheet.appendChild(title);
        // Create cross word box
        for (var j = 0; j < this.size; j++) {
            var row = document.createElement("div");
            row.className = 'row justify-content-center';
            for (var i = 0; i < this.size * 1.5; i++) {
                if (2 * i >= j && i < this.size + Math.floor(j / 2)) {
                    var div = document.createElement("div");
                    div.style.width = Math.floor(720 / (this.size)) + "px";
                    div.style.height = Math.floor(720 / (this.size)) + "px";
                    div.className = "hex";
                    if (this.crossGrid[i][j])
                        div.innerHTML = this.crossGrid[i][j];
                    if (this.grid[i][j])
                        div.className = "hex hex-border";
                    row.appendChild(div);
                }
            }
            worksheet.appendChild(row);
        }

        let hr = document.createElement('hr');
        worksheet.appendChild(hr);

        var bank = document.createElement("div");
        bank.className = "row";
        var up = document.createElement("span");
        up.className = "col-md-4 d-block";
        var upTitle = document.createElement("h4");
        upTitle.innerHTML = "Up Hints";
        up.appendChild(upTitle);
        for (var i = 0; i < this.up.length; i++) {
            var p = document.createElement("p");
            p.innerHTML = (i + 1) + ". " + this.up[i];
            up.append(p);
            renderMathInElement(p);
        }
        bank.appendChild(up);
        var right = document.createElement("span");
        right.className = "col-md-4 d-block";
        var rightTitle = document.createElement("h4");
        rightTitle.innerHTML = "Right Hints";
        right.appendChild(rightTitle);
        for (var i = 0; i < this.right.length; i++) {
            var p = document.createElement("p");
            p.innerHTML = (i + 1) + ". " + this.right[i];
            right.append(p);
            renderMathInElement(p);
        }
        bank.appendChild(right);
        var down = document.createElement("span");
        down.className = "col-md-4 d-block";
        var downTitle = document.createElement("h4");
        downTitle.innerHTML = "Down Hints";
        down.appendChild(downTitle);
        for (var i = 0; i < this.down.length; i++) {
            var p = document.createElement("p");
            p.innerHTML = (i + 1) + ". " + this.down[i];
            down.append(p);
            renderMathInElement(p);
        }
        bank.appendChild(down);
        worksheet.appendChild(bank);
    };
}